<ng-container [ngSwitch]="tag">
  <h1 *ngSwitchCase="'h1'" [ngClass]="class">{{ content }}</h1>
  <h2 *ngSwitchCase="'h2'" [ngClass]="class">{{ content }}</h2>
  <h3 *ngSwitchCase="'h3'" [ngClass]="class">{{ content }}</h3>
  <h4 *ngSwitchCase="'h4'" [ngClass]="class">{{ content }}</h4>
  <h5 *ngSwitchCase="'h5'" [ngClass]="class">{{ content }}</h5>
  <h6 *ngSwitchCase="'h6'" [ngClass]="class">{{ content }}</h6>
  <p *ngSwitchDefault [ngClass]="class">{{ content }}</p>
</ng-container>
